<template>
  <v-card flat class="mx-5 my-5">
    <v-form ref="form" v-model="brg.valid" lazy-validation>
      <v-text-field v-model="brg.Kode" label="Kode"></v-text-field>
      <v-text-field v-model="brg.SKU" label="SKU" required></v-text-field>
      <v-text-field v-model="brg.Nama" label="Nama"></v-text-field>

      <v-combobox
        v-model="brg.Brand"
        :items="brands"
        item-text="brand"
        item-value="brand"
        :rules="[(v) => !!v || 'Brand is required']"
        label="Brand"
        required
      ></v-combobox>
      <v-text-field v-model="brg.JenisMotor" label="Jenis Motor"></v-text-field>

      <v-text-field
        v-model="brg.HETLama"
        label="HET Lama"
        @keyup="brg.HETLama=thousandSeparator(brg.HETLama)"
        
      ></v-text-field>
      <v-text-field
        v-model="brg.HETBaru"
        label="HET Baru"
        @keyup="brg.HETBaru=thousandSeparator(brg.HETBaru)"
       
      ></v-text-field>
      <v-text-field
        v-model="brg.Kenaikan"
        label="Kenaikan"
        @keyup="brg.Kenaikan=thousandSeparator(brg.Kenaikan)"
       
      ></v-text-field>
      <v-text-field
        v-model="brg.HargaJual"
        label="Harga Jual"
        @keyup="brg.HargaJual=thousandSeparator(brg.HargaJual)"
      
      ></v-text-field>
      <v-text-field
        v-model="brg.HargaBeli"
        label="Harga Beli"
        @keyup="brg.HargaBeli=thousandSeparator(brg.HargaBeli)"
       
      ></v-text-field>
      <v-text-field
        v-model="brg.Stok"
        label="Stok"
        @keyup="brg.Stok=thousandSeparator(brg.Stok)"
  
      ></v-text-field>
      <v-text-field v-model="brg.Keterangan" label="Keterangan"></v-text-field>

      <v-btn
        align="right"
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="validate"
      >
        Submit
      </v-btn>

      <!-- <v-btn color="error" class="mr-4" @click="reset"> Reset Form </v-btn>

      <v-btn color="warning" @click="resetValidation"> Reset Validation </v-btn> -->
    </v-form>
  </v-card>
</template>
<script>
import api from "@/services/http";

export default {
  props: {
    title: String,
  },
  data: () => ({
    valid: true,
    token: localStorage.token,
    brg: {
      Kode: "",
      SKU: "",
      Nama: "",
      Brand: "",
      JenisMotor: "",
      HETLama: "",
      HETBaru: "",
      Kenaikan: "",
      HargaJual: "",
      HargaBeli: "",
      Stok: "",
      Keterangan: "",
    },

    brands: [
      "YAMAHA",
      "HONDA",
      "ASPIRA",
      "TAKAYAMA",
      "FEDERAL",
      "YUASA",
      "ALKUN",
      "SGP",
      "LAIN-LAIN",
    ],
  }),
  methods: {
    thousandSeparator(x) {
      if(x != null) {
        x = parseFloat(x.toString().replaceAll(",", ""));
        x= x.toLocaleString('en-US');
      }
      return x;
    },
    validate() {
      this.$refs.form.validate();
      if (this.title == "Add") {
        api
          .post(
            "create?token=" + this.token,
            {
              kode: this.brg.Kode,
              sku: this.brg.SKU,
              nama: this.brg.Nama,
              brand: this.brg.Brand,
              JenisMotor: this.brg.JenisMotor,
              HET: this.brg.HETLama == null ? null : this.brg.HETLama.replaceAll(",", ""),
              HET_NEW: this.brg.HETBaru == null ? null : this.brg.HETBaru.toString().replaceAll(",", ""),
              kenaikan: this.brg.Kenaikan == null ? null : this.brg.Kenaikan.toString().replaceAll(",", ""),
              HrgJual: this.brg.HargaJual == null ? null : this.brg.HargaJual.toString().replaceAll(",", ""),
              Stok: this.brg.Stok == null ? null : this.brg.Stok.toString().replaceAll(",", ""),
              hrgBeli: this.brg.HargaBeli == null ? null : this.brg.HargaBeli.toString().replaceAll(",", ""),
              keterangan: this.brg.Keterangan,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${this.token}`,
              },
            }
          )
          .then((res) => {
            if (res) {
              // this.Alert = true
              console.log(res);
              this.$emit("close-add-dialog");
            } else {
              //
            }
          });
      } else if (this.title == "Edit") {
        api
          .put(
            "update/" + localStorage.brgEditID + "?token=" + this.token,
            {
              kode: this.brg.Kode,
              sku: this.brg.SKU,
              nama: this.brg.Nama,
              brand: this.brg.Brand,
              JenisMotor: this.brg.JenisMotor,
              HET: this.brg.HETLama == null ? null : this.brg.HETLama.replaceAll(",", ""),
              HET_NEW: this.brg.HETBaru == null ? null : this.brg.HETBaru.toString().replaceAll(",", ""),
              kenaikan: this.brg.Kenaikan == null ? null : this.brg.Kenaikan.toString().replaceAll(",", ""),
              HrgJual: this.brg.HargaJual == null ? null : this.brg.HargaJual.toString().replaceAll(",", ""),
              Stok: this.brg.Stok == null ? null : this.brg.Stok.toString().replaceAll(",", ""),
              hrgBeli: this.brg.HargaBeli == null ? null : this.brg.HargaBeli.toString().replaceAll(",", ""),
              keterangan: this.brg.Keterangan,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${this.token}`,
              },
            }
          )
          .then((res) => {
            if (res) {
              // this.Alert = true
              console.log(res);
              this.$emit("close-add-dialog");
            } else {
              //
            }
          });
      }
    },
  },
  mounted() {
    console.log("mounted detail start; ID  : " + localStorage.brgEditID);
    if (localStorage.brgEditID) {
      api
        .get("barangs/" + localStorage.brgEditID + "?token=" + this.token)
        .then((res) => {
          console.log(res.data);
          this.brg.Kode = res.data.kode;
          this.brg.SKU = res.data.sku;
          this.brg.Nama = res.data.nama;
          this.brg.Brand = res.data.brand;
          this.brg.JenisMotor = res.data.JenisMotor;
          this.brg.HETLama = this.thousandSeparator(res.data.HET);
          this.brg.HETBaru = this.thousandSeparator(res.data.HET_NEW);
          this.brg.Kenaikan = this.thousandSeparator(res.data.kenaikan);
          this.brg.HargaJual = this.thousandSeparator(res.data.HrgJual);
          this.brg.HargaBeli = this.thousandSeparator(res.data.HrgBeli);
          this.brg.Stok = this.thousandSeparator(res.data.Stok);
          this.brg.Keterangan = res.data.keterangan;
        });
    }

  },
  created() {
    api
      .get("brands?token=" + this.token)
      .then((res) => {
        console.log("brands : "); 
        
        this.brands = res.data;
        console.log(this.brands);
      });
  },
  watch: {
    title(txt) {
      console.log(
        "watch detail start; ID  : " +
          localStorage.brgEditID +
          " title : " +
          txt
      );
      if (txt == "Add") {
        this.brg.Kode = null;
        this.brg.SKU = null;
        this.brg.Nama = null;
        this.brg.Brand = null;
        this.brg.JenisMotor = null;
        this.brg.HETLama = null;
        this.brg.HETBaru = null;
        this.brg.Kenaikan = null;
        this.brg.HargaJual = null;
        this.brg.HargaBeli = null;
        this.brg.Stok = null;
        this.brg.Keterangan = null;
        this.$refs.form.resetValidation();
      } else if (txt == "Edit") {
        api
          .get("barangs/" + localStorage.brgEditID + "?token=" + this.token)
          .then((res) => {
           
            this.brg.Kode = res.data.kode;
            this.brg.SKU = res.data.sku;
            this.brg.Nama = res.data.nama;
            this.brg.Brand = res.data.brand;
            this.brg.JenisMotor = res.data.JenisMotor;
            this.brg.HETLama = this.thousandSeparator(res.data.HET);
            this.brg.HETBaru = this.thousandSeparator(res.data.HET_NEW);
            this.brg.Kenaikan = this.thousandSeparator(res.data.kenaikan);
            this.brg.HargaJual = this.thousandSeparator(res.data.HrgJual);
            this.brg.HargaBeli = this.thousandSeparator(res.data.HrgBeli);
            this.brg.Stok = this.thousandSeparator(res.data.Stok);
            this.brg.Keterangan = res.data.keterangan;
            console.log(this.brg);
          });
      }
    },
  },
};
</script>